import { Group, Loader, Text } from '@mantine/core'

type Props = {
  label?: string
  size?: 'xs' | 'sm' | 'md'
}

/** Индикатор в строке / внутри блока */
export function InlineLoader({ label = 'Загрузка…', size = 'sm' }: Props) {
  return (
    <Group gap="sm" justify="center" align="center" wrap="nowrap">
      <Loader size={size} type="oval" />
      {label ? (
        <Text size={size === 'xs' ? 'xs' : 'sm'} c="dimmed">
          {label}
        </Text>
      ) : null}
    </Group>
  )
}
